import type { FC } from 'react';

import { useToggle } from '../../hooks/use-toggle';
import type { CollapsiblePropsInterface } from './types/collapsible.types';

/**
 * @since 4.1.0
 */
export const Collapsible: FC<CollapsiblePropsInterface> = (props) => {
  const { children, defaultCollapsed = false } = props;
  const [collapsed, toggle] = useToggle(defaultCollapsed);
  return typeof children === 'function' ? children(collapsed, toggle) : null;
};

Collapsible.displayName = 'Collapsible';
